// This file is automatically generated by Vocab.
// To make changes update translation.json files directly.

import type { FormatXMLElementFn } from '@vocab/core';
import { createLanguage, createTranslationFile } from '@vocab/core/runtime';

const translations = createTranslationFile<
  | 'en'
  | 'th'
  | 'id'
  | 'zh'
  | 'en-AU'
  | 'en-HK'
  | 'en-ID'
  | 'en-MY'
  | 'en-NZ'
  | 'en-PH'
  | 'en-SG'
  | 'en-TH'
  | 'th-TH'
  | 'id-ID'
  | 'zh-HK'
  | 'en-PSEUDO',
  {
    'we couldnt find that page': () =>
      | 'We couldn’t find that page'
      | 'เราไม่พบหน้าที่คุณต้องการ'
      | 'Kami tidak dapat menemukan halaman tersebut'
      | '[Ŵẽẽẽ çöööǚǚǚƚƌกี้’ṯ ƒìììกี้ƌ ṯḩăăăṯ ƥăăăģẽẽẽ]';
    'maybe we can help': () =>
      | 'But maybe we can help you find what you need.'
      | 'เราอาจสามารถช่วยคุณค้นหาสิ่งที่คุณต้องการได้'
      | 'Tapi mungkin kami dapat membantu menemukan apa yang Anda butuhkan.'
      | '[ẞǚǚǚṯ m̂ăăăýýýßẽẽẽ ŵẽẽẽ çăăăกี้ ḩẽẽẽƚƥ ýýýöööǚǚǚ ƒìììกี้ƌ ŵḩăăăṯ ýýýöööǚǚǚ กี้ẽẽẽẽẽẽƌ.]';
    'check the url': () =>
      | 'Check that the URL is correct.'
      | 'ตรวจสอบว่า URL ถูกต้องหรือไม่'
      | 'Cek apakah URL sudah benar.'
      | '[Çḩẽẽẽçķ ṯḩăăăṯ ṯḩẽẽẽ ǙŘŁ ìììš çöööřřẽẽẽçṯ.]';
    'try going back': () =>
      | 'Try going back to the previous page.'
      | 'ลองกลับไปที่หน้าก่อนนี้'
      | 'Coba kembali ke halaman sebelumnya.'
      | '[Ṯřýýý ģöööìììกี้ģ ßăăăçķ ṯööö ṯḩẽẽẽ ƥřẽẽẽṽìììöööǚǚǚš ƥăăăģẽẽẽ.]';
    'call customer service': <T = string>(values: {
      TextLink: FormatXMLElementFn<T>;
    }) => ReturnType<FormatXMLElementFn<T>>;
    'call customer service asia': <T = string>(values: {
      TextLink: FormatXMLElementFn<T>;
    }) => ReturnType<FormatXMLElementFn<T>>;
  }
>({
  en: createLanguage({
    'we couldnt find that page': 'We couldn’t find that page',
    'maybe we can help': 'But maybe we can help you find what you need.',
    'check the url': 'Check that the URL is correct.',
    'try going back': 'Try going back to the previous page.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Contact Customer Service via our <TextLink>Contact Us</TextLink> page.',
  }),
  th: createLanguage({
    'we couldnt find that page': 'เราไม่พบหน้าที่คุณต้องการ',
    'maybe we can help': 'เราอาจสามารถช่วยคุณค้นหาสิ่งที่คุณต้องการได้',
    'check the url': 'ตรวจสอบว่า URL ถูกต้องหรือไม่',
    'try going back': 'ลองกลับไปที่หน้าก่อนนี้',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'ติดต่อฝ่ายบริการลูกค้าผ่านหน้า<TextLink>ติดต่อเรา</TextLink>',
  }),
  id: createLanguage({
    'we couldnt find that page': 'Kami tidak dapat menemukan halaman tersebut',
    'maybe we can help':
      'Tapi mungkin kami dapat membantu menemukan apa yang Anda butuhkan.',
    'check the url': 'Cek apakah URL sudah benar.',
    'try going back': 'Coba kembali ke halaman sebelumnya.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Hubungi Layanan Pelanggan melalui halaman <TextLink>Hubungi Kami</TextLink> kami.',
  }),
  zh: createLanguage({
    'we couldnt find that page': 'We couldn’t find that page',
    'maybe we can help': 'But maybe we can help you find what you need.',
    'check the url': 'Check that the URL is correct.',
    'try going back': 'Try going back to the previous page.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Contact Customer Service via our <TextLink>Contact Us</TextLink> page.',
  }),
  'en-AU': createLanguage({
    'we couldnt find that page': 'We couldn’t find that page',
    'maybe we can help': 'But maybe we can help you find what you need.',
    'check the url': 'Check that the URL is correct.',
    'try going back': 'Try going back to the previous page.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Contact Customer Service via our <TextLink>Contact Us</TextLink> page.',
  }),
  'en-HK': createLanguage({
    'we couldnt find that page': 'We couldn’t find that page',
    'maybe we can help': 'But maybe we can help you find what you need.',
    'check the url': 'Check that the URL is correct.',
    'try going back': 'Try going back to the previous page.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Contact Customer Service via our <TextLink>Contact Us</TextLink> page.',
  }),
  'en-ID': createLanguage({
    'we couldnt find that page': 'We couldn’t find that page',
    'maybe we can help': 'But maybe we can help you find what you need.',
    'check the url': 'Check that the URL is correct.',
    'try going back': 'Try going back to the previous page.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Contact Customer Service via our <TextLink>Contact Us</TextLink> page.',
  }),
  'en-MY': createLanguage({
    'we couldnt find that page': 'We couldn’t find that page',
    'maybe we can help': 'But maybe we can help you find what you need.',
    'check the url': 'Check that the URL is correct.',
    'try going back': 'Try going back to the previous page.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Contact Customer Service via our <TextLink>Contact Us</TextLink> page.',
  }),
  'en-NZ': createLanguage({
    'we couldnt find that page': 'We couldn’t find that page',
    'maybe we can help': 'But maybe we can help you find what you need.',
    'check the url': 'Check that the URL is correct.',
    'try going back': 'Try going back to the previous page.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Contact Customer Service via our <TextLink>Contact Us</TextLink> page.',
  }),
  'en-PH': createLanguage({
    'we couldnt find that page': 'We couldn’t find that page',
    'maybe we can help': 'But maybe we can help you find what you need.',
    'check the url': 'Check that the URL is correct.',
    'try going back': 'Try going back to the previous page.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Contact Customer Service via our <TextLink>Contact Us</TextLink> page.',
  }),
  'en-SG': createLanguage({
    'we couldnt find that page': 'We couldn’t find that page',
    'maybe we can help': 'But maybe we can help you find what you need.',
    'check the url': 'Check that the URL is correct.',
    'try going back': 'Try going back to the previous page.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Contact Customer Service via our <TextLink>Contact Us</TextLink> page.',
  }),
  'en-TH': createLanguage({
    'we couldnt find that page': 'We couldn’t find that page',
    'maybe we can help': 'But maybe we can help you find what you need.',
    'check the url': 'Check that the URL is correct.',
    'try going back': 'Try going back to the previous page.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Contact Customer Service via our <TextLink>Contact Us</TextLink> page.',
  }),
  'th-TH': createLanguage({
    'we couldnt find that page': 'เราไม่พบหน้าที่คุณต้องการ',
    'maybe we can help': 'เราอาจสามารถช่วยคุณค้นหาสิ่งที่คุณต้องการได้',
    'check the url': 'ตรวจสอบว่า URL ถูกต้องหรือไม่',
    'try going back': 'ลองกลับไปที่หน้าก่อนนี้',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'ติดต่อฝ่ายบริการลูกค้าผ่านหน้า<TextLink>ติดต่อเรา</TextLink>',
  }),
  'id-ID': createLanguage({
    'we couldnt find that page': 'Kami tidak dapat menemukan halaman tersebut',
    'maybe we can help':
      'Tapi mungkin kami dapat membantu menemukan apa yang Anda butuhkan.',
    'check the url': 'Cek apakah URL sudah benar.',
    'try going back': 'Coba kembali ke halaman sebelumnya.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Hubungi Layanan Pelanggan melalui halaman <TextLink>Hubungi Kami</TextLink> kami.',
  }),
  'zh-HK': createLanguage({
    'we couldnt find that page': 'We couldn’t find that page',
    'maybe we can help': 'But maybe we can help you find what you need.',
    'check the url': 'Check that the URL is correct.',
    'try going back': 'Try going back to the previous page.',
    'call customer service': 'Call Customer Service on <TextLink></TextLink>',
    'call customer service asia':
      'Contact Customer Service via our <TextLink>Contact Us</TextLink> page.',
  }),
  'en-PSEUDO': createLanguage({
    'we couldnt find that page':
      '[Ŵẽẽẽ çöööǚǚǚƚƌกี้’ṯ ƒìììกี้ƌ ṯḩăăăṯ ƥăăăģẽẽẽ]',
    'maybe we can help':
      '[ẞǚǚǚṯ m̂ăăăýýýßẽẽẽ ŵẽẽẽ çăăăกี้ ḩẽẽẽƚƥ ýýýöööǚǚǚ ƒìììกี้ƌ ŵḩăăăṯ ýýýöööǚǚǚ กี้ẽẽẽẽẽẽƌ.]',
    'check the url': '[Çḩẽẽẽçķ ṯḩăăăṯ ṯḩẽẽẽ ǙŘŁ ìììš çöööřřẽẽẽçṯ.]',
    'try going back':
      '[Ṯřýýý ģöööìììกี้ģ ßăăăçķ ṯööö ṯḩẽẽẽ ƥřẽẽẽṽìììöööǚǚǚš ƥăăăģẽẽẽ.]',
    'call customer service':
      '[Çăăăƚƚ Çǚǚǚšṯöööm̂ẽẽẽř Šẽẽẽřṽìììçẽẽẽ öööกี้ <TextLink></TextLink>]',
    'call customer service asia':
      '[Çöööกี้ṯăăăçṯ Çǚǚǚšṯöööm̂ẽẽẽř Šẽẽẽřṽìììçẽẽẽ ṽìììăăă öööǚǚǚř <TextLink>Çöööกี้ṯăăăçṯ Ǚš</TextLink> ƥăăăģẽẽẽ.]',
  }),
});

export default translations;
